import { render, staticRenderFns } from "./FoundStartups.vue?vue&type=template&id=f7586858&scoped=true"
import script from "./FoundStartups.vue?vue&type=script&setup=true&lang=js"
export * from "./FoundStartups.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7586858",
  null
  
)

export default component.exports